"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocOpenedPositive = function SvgBDocOpenedPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M85.093 143.522H8.675A8.682 8.682 0 010 134.868V81.954a2.107 2.107 0 114.215 0v52.914a4.46 4.46 0 004.46 4.454h76.418a2.107 2.107 0 110 4.214v-.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M94.99 143.522a2.107 2.107 0 110-4.214 4.46 4.46 0 004.461-4.454V73.756H2.107A2.107 2.107 0 010 71.65V8.675A8.682 8.682 0 018.675 0h3.365a2.107 2.107 0 010 4.215H8.675a4.468 4.468 0 00-4.46 4.46v60.866h97.344c1.163 0 2.107.944 2.107 2.108v63.22a8.682 8.682 0 01-8.675 8.653z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M101.692 63.922a2.107 2.107 0 01-2.107-2.107V8.675a4.468 4.468 0 00-4.46-4.46H21.971a2.107 2.107 0 110-4.215h73.152a8.682 8.682 0 018.675 8.675v53.14a2.107 2.107 0 01-2.107 2.107zM35.305 37.342h-16.67a2.107 2.107 0 01-2.107-2.108V18.706c0-1.164.944-2.107 2.108-2.107h16.669c1.163 0 2.107.943 2.107 2.107v6.533a2.107 2.107 0 11-4.215 0v-4.426H20.743v12.314h14.562a2.107 2.107 0 010 4.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M85.093 37.342h-36.59a2.107 2.107 0 010-4.215h36.59a2.107 2.107 0 110 4.215zM85.093 20.743h-36.59a2.107 2.107 0 010-4.215h36.59a2.107 2.107 0 110 4.215zM85.093 54.004H18.636a2.107 2.107 0 110-4.215h66.457a2.107 2.107 0 110 4.215zM85.093 110.43H18.636a2.107 2.107 0 110-4.214h66.457a2.107 2.107 0 110 4.214zM85.093 93.832H18.636a2.107 2.107 0 110-4.215h66.457a2.107 2.107 0 110 4.215zM85.093 127.092H18.636a2.107 2.107 0 110-4.214h66.457a2.107 2.107 0 110 4.214z",
    fill: "#285"
  })));
};

var _default = SvgBDocOpenedPositive;
exports["default"] = _default;